import React from "react";
import "./css/Herocomponenet.css";
import roundimage from "../assets/table1.png";
import newimage from "../assets/newimage.png";
import lastimg from "../assets/lastimg.jpeg";
import AnimateInView from "./AnimateInView";
import { Link } from "react-router-dom";
import WaveText from "./WaveText";
import ImageLoader from "./ImageLoader";
const HeroComponent = () => {
  const data = [
    { text: "10K+", content: "Happy Customers" },
 
    { text: "100+", content: "Projects" },
  ];
  return (
    <main className="hero-container-div1">
         <AnimateInView delay={0.4} >
      <div className="hero-container-div1-content1">
        <div className="hero-container-div1-content1-content1">
          <div className="rating-and-text-div">
            <div className="rating-div-text">
              <p className="rating-text-para">
                CRAFTING HOMES FOR MODERN LIVING
              </p>
            </div>
            <div className="rating-div-rating-number">
              {data.map((item, index) => (
                <div key={index} className="rating-div-rating-number-content">
                  <p className="rating-number">{item.text}</p>
                  <p className="rating-content">{item.content}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="hero-container-div1-content1-content1-content2">
            <div className="hero-container-div1-content1-content1-content2-content1">
              <div className="line1-hero"></div>
              <div className="round-image image-container2">
              <ImageLoader src={roundimage} alt="Round" />
              </div>
              <div className="line1-hero"></div>
              <h1 className="heading-large color-white absolute-text">
               
                <WaveText text=" BEAUTY IN SIMPLICITY" />
              </h1>
            </div>
            <div className="last-hero-div">
              <div className="last-hero-div-content-image">
                <div className="image-radius-image">
                <ImageLoader src={newimage} alt="New" />
                </div>
              </div>
              <div className="last-hero-div-content-text">
                <p className="last-hero-div-content-text-para">
                  We bring you innovative solutions, expert advice, and
                  cutting-edge technology to create intelligent homes
                </p>
                <Link to="/contact">
                <button  className="button-89">
                
                Read More
                </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-container-div1-content1-content2">
          <div className="last-hero-image-div">
          <ImageLoader src={lastimg} alt="Last" />
          </div>
          <p className="last-hero-text">
            Module & Sense is your ultimate resource for modular living.
          </p>
        </div>
      </div>
      </AnimateInView>
    </main>
  );
};
export default HeroComponent;
